<div [id]="this.idVal" class="container st-form">
  <div class="col2 d-grid gap-2 d-md-flex justify-content-md-center align-items-center">
    <!--<div class="accordion-body" *ngFor="let returnTypeCodeCheckbox of returnTypeCodeCheckboxes; let i9 = index">-->
    <a *ngFor="let elementTag of this.elementTags; let i1 = index" [id]="'horiz-nav-{{i1}}-button-id'" (click)="this.scrollToSelected(elementTag['id'])">
      <span class="webtext-black horizNavBarFixed" *ngIf="elementTag['selected']">
        <u class="horizNavBarUnderline"><b>{{elementTag['name']}}</b></u>
      </span>
      <span class="webtext-black horizNavBarFixed" *ngIf="!elementTag['selected']"><b>{{elementTag['name']}}</b></span>
      <span>&nbsp;&nbsp;&nbsp;</span>
    </a>
  </div>
</div>
